import cloneDeep from 'lodash/cloneDeep';
import { createSlice } from '@reduxjs/toolkit';
import {
  getTenantConfigThunk,
  setUser as setUserReducer,
  toggleForceLogout as toggleForceLogoutReducer,
  clearTenantConfig as clearTenantConfigReducer,
} from './loginActions';

export interface LoginState {
  clientConfig: any;
  forcedLogout: boolean;
  loading: boolean;
  tenantConfig: any;
  user: any;
}

const initialState: LoginState = {
  clientConfig: {},
  forcedLogout: false,
  loading: false,
  tenantConfig: null,
  user: {},
};

const loginSlice = createSlice({
  name: 'Login',
  initialState,
  reducers: {
    setUser: setUserReducer,
    toggleForceLogout: toggleForceLogoutReducer,
    clearTenantConfig: clearTenantConfigReducer,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTenantConfigThunk.pending, (state) => {
        state.loading = true;
        state.tenantConfig = null;
      })
      .addCase(getTenantConfigThunk.fulfilled, (state, action: any) => {
        const tenantConfig = cloneDeep(action.payload);
        state.tenantConfig = tenantConfig;
        state.loading = false;
      })
      .addCase(getTenantConfigThunk.rejected, (state) => {
        state.tenantConfig = null;
        state.loading = false;
      });
  },
});

export const { setUser, toggleForceLogout, clearTenantConfig } = loginSlice.actions;
export default loginSlice.reducer;
